@let val = value();
<section class="ca-details">
  <h1 class="ca-details__header">{{ title() }}</h1>
  <div class="ca-details__buttons">
    <div class="ca-details__buttons-left">
      <button mat-button type="button" class="button" (click)="onBack()">
        {{ labels.back }}
      </button>
    </div>
    <div class="ca-details__buttons-right">
      @if (showRenew()) {
        <button mat-button type="button" class="button" (click)="onRenew()">
          {{ labels.actions.renew.label }}
        </button>
      }
      @if (showRevoke()) {
        <button mat-button type="button" class="button" (click)="onRevoke()">
          {{ labels.actions.revoke.label }}
        </button>
      }
      @if (showGenerateCrl()) {
        <button
          mat-button
          type="button"
          class="button"
          (click)="onGenerateCrl()"
        >
          {{ labels.actions.generateCrl.label }}
        </button>
      }
    </div>
  </div>
  @if (val) {
    <div class="ca-details__body">
      <div class="ca-details__key ca-details__key--top-left">
        {{ labels.data.caName }}
      </div>
      <div class="ca-details__value ca-details__value--top-right">
        {{ val.caName || labels.na }}
      </div>
      <div class="ca-details__key">
        {{ labels.data.token }}
      </div>
      <div class="ca-details__value">
        {{ val.token || labels.na }}
      </div>
      <div class="ca-details__key">
        {{ labels.data.signKey }}
      </div>
      <div class="ca-details__value">
        {{ val.signKey || labels.na }}
      </div>
      <div class="ca-details__key">
        {{ labels.data.signingAlgo }}
      </div>
      <div class="ca-details__value">
        {{ val.signingAlgo || labels.na }}
      </div>
      <div class="ca-details__key">
        {{ labels.data.defaultCRLDistPoint }}
      </div>
      <div class="ca-details__value">
        {{ val.defaultCRLDistPoint || labels.na }}
      </div>
      <div class="ca-details__key">
        {{ labels.data.defaultOCSPServiceLocator }}
      </div>
      <div class="ca-details__value">
        {{ val.defaultOCSPServiceLocator || labels.na }}
      </div>
      <div class="ca-details__key">
        {{ labels.data.useLdapDNOrder }}
      </div>
      <div class="ca-details__value">
        <!-- Possible values: true (checkbox) - false (checkbox) - null ("n/a") -->
        @if (val.useLdapDNOrder) {
          <svg-icon icon="checkbox-checked"></svg-icon>
        } @else if (val.useLdapDNOrder === false) {
          <svg-icon icon="checkbox-unchecked"></svg-icon>
        } @else {
          {{ labels.na }}
        }
      </div>
      <div class="ca-details__key">
        {{ labels.data.subjectDn }}
      </div>
      <div class="ca-details__value">
        {{ val.subjectDn || labels.na }}
      </div>
      <div class="ca-details__key">
        {{ labels.data.expireTime }}
      </div>
      <div class="ca-details__value">
        @if (val.expireTime) {
          {{ val.expireTime | date }}
        } @else {
          {{ labels.na }}
        }
      </div>
      <div class="ca-details__key ca-details__key--bottom-left">
        {{ labels.data.signedBy }}
      </div>
      <div class="ca-details__value ca-details__value--bottom-right">
        {{ val.signedBy || labels.na }}
      </div>
      <div class="ca-details__key ca-details__key--bottom-left">
        {{ labels.data.profile }}
      </div>
      <div class="ca-details__value ca-details__value--bottom-right">
        {{ val.profile || labels.na }}
      </div>
    </div>
    <div class="ca-details__certchain">
      <h2 class="ca-details__certchain-header">
        {{ labels.certificateChain }}
      </h2>
      <div class="ca-details__certchain-body">
        @for (cert of val.certificateChain; track $index) {
          <app-monospaced-block>{{ cert }}</app-monospaced-block>
        }
      </div>
    </div>
  }
</section>
